import type * as core from '../../../../../../../core'

/* eslint-disable sort-keys */

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Department Performance',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'Density',
                          points: {
                            '@': 'densityQuery',
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'ASF',
                  yLabel: 'GL Expense Entry Amount',
                },
              },
            ],
          },
          type: 'scatter',
        },
      },
    },
  },
  subqueries: {
    densityQuery: {
      target: 'ent:!org:!dept',
      selection: {
        '{}': {
          x: {
            '+': {
              '??': [
                {
                  '@': 'rooms',
                },
                {
                  '[]': [0],
                },
              ],
            },
          },
          y: {
            '+': {
              '@': 'Expenses',
            },
          },
          name: {
            '++': [
              {
                '@.': '!name',
              },
              ': ',
              {
                'fmt.num': [
                  {
                    if: [
                      [
                        {
                          '=': [
                            {
                              '@>': 'x',
                            },
                            0,
                          ],
                        },
                        0,
                      ],
                      {
                        '/': [
                          {
                            '@>': 'y',
                          },
                          {
                            '@>': 'x',
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        },
      },
      subqueries: {
        rooms: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!space',
          },
          using: 'roomAssignments',
          target: 'ent:!space:!room',
          selection: {
            '@.': '!sqft',
          },
        },
        Expenses: {
          ref: {
            attr: 'attr:ent#!gl_exp#!entry:!proj',
          },
          using: 'projectAssignments',
          target: 'ent:!gl_exp:!entry',
          selection: {
            '@.': '!amount',
          },
        },
        roomAssignments: {
          ref: {
            attr: 'attr:ent#!org_space#!entry:!org',
            inherit: '-',
          },
          target: 'ent:!org_space:!entry',
        },
        projectAssignments: {
          ref: {
            attr: 'attr:ent#!projects#!proj:!org',
            inherit: '-',
          },
          target: 'ent:!projects:!proj',
        },
      },
    },
  },
}
